(() => {
  if (window.RavinCartCompleteEditLoaded) return;
  window.RavinCartCompleteEditLoaded = true;
  const instances = new WeakMap();
  const parser = new DOMParser();

  function setup(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const track = root.querySelector('[data-rcc-track]');
    const counter = root.querySelector('[data-rcc-counter]');
    const url = root.dataset.rccUrl;
    const section = root.dataset.rccSection;
    const product = root.dataset.rccProduct;
    const limit = Number(root.dataset.rccLimit) || 4;
    const [addText, addedText, errorText] = (root.querySelector('[data-rcc-copy]')?.textContent || '').trim().split('|');

    function adjust() {
      const count = track.querySelectorAll('[data-rcc-card]').length;
      root.dataset.rccHasCards = count ? 'true' : 'false';
      if (counter) counter.textContent = count + ' / ' + limit;
    }

    function updateVariant(select) {
      const card = select.closest('[data-rcc-card]');
      const option = select.selectedOptions[0];
      if (!option || !card) return;
      const current = card.querySelector('[data-rcc-final]');
      const original = card.querySelector('[data-rcc-original]');
      if (current) current.textContent = option.dataset.price || '';
      if (original) {
        original.textContent = option.dataset.original || '';
        original.hidden = option.dataset.discounted !== 'true';
      }
    }

    async function showRecommendations() {
      if (!product || !url || !section || !window.fetch) return;
      for (const intent of ['complementary','related']) {
        if (signal.aborted) return;
        try {
          const endpoint = new URL(url, location.origin);
          endpoint.searchParams.set('section_id', section);
          endpoint.searchParams.set('product_id', product);
          endpoint.searchParams.set('limit', String(Math.min(10, Math.max(limit + 3, 6))));
          endpoint.searchParams.set('intent', intent);
          const response = await fetch(endpoint.href, {signal});
          if (!response.ok) continue;
          const html = parser.parseFromString(await response.text(), 'text/html');
          const recommendedRoot = html.querySelector('[data-rcc-root]');
          const newTrack = recommendedRoot?.querySelector('[data-rcc-track]');
          if (recommendedRoot?.dataset.rccSource !== 'recommendations' || !newTrack?.querySelector('[data-rcc-card]')) continue;
          track.replaceChildren(...Array.from(newTrack.children));
          root.dataset.rccSource = intent;
          adjust();
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
    }

    async function refreshCart(variantId) {
      const items = document.getElementById('main-cart-items');
      const footer = document.getElementById('main-cart-footer');
      const cartStateResponse = await fetch((window.routes?.cart_url || '/cart') + '.js', {credentials:'same-origin', signal});
      if (!cartStateResponse.ok) throw new Error('Cart fetch failed');
      const state = await cartStateResponse.json();
      if (!items || !footer) { location.reload(); return; }
      const ids = [items.dataset.id, footer.dataset.id, 'cart-icon-bubble'].filter(Boolean);
      const path = window.routes?.cart_url || '/cart';
      const response = await fetch(path + '?sections=' + encodeURIComponent(ids.join(',')), {signal, credentials:'same-origin'});
      if (!response.ok) throw new Error('Cart sections failed');
      const sections = await response.json();
      for (const [id, selector] of [[ids[0], '#main-cart-items'], [ids[1], '#main-cart-footer']]) {
        const freshHTML = sections[id];
        if (!freshHTML) throw new Error('Missing refreshed cart section');
        const html = parser.parseFromString(freshHTML, 'text/html');
        const source = html.querySelector(selector + ' .js-contents');
        const target = document.querySelector(selector + ' .js-contents');
        if (!source || !target) throw new Error('Incomplete cart section');
        target.innerHTML = source.innerHTML;
      }
      document.querySelector('cart-items')?.classList.toggle('is-empty', !state.item_count);
      footer.classList.toggle('is-empty', !state.item_count);
      const bubbleHTML = sections['cart-icon-bubble'];
      if (bubbleHTML) {
        const html = parser.parseFromString(bubbleHTML, 'text/html');
        const source = html.querySelector('#cart-icon-bubble') || html.querySelector('.shopify-section');
        const target = document.querySelector('#cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {source:'ravin-cart-complete-edit', cartData:state, variantId});
      }
      const currentIds = new Set(state.items.map(item => String(item.product_id)));
      track.querySelectorAll('[data-rcc-card]').forEach(card => {
        if (currentIds.has(card.dataset.product)) card.remove();
      });
      adjust();
    }

    async function addItem(event) {
      const form = event.target.closest('[data-rcc-add-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('.rcc__add');
      const feedback = form.querySelector('[data-rcc-feedback]');
      const selected = form.querySelector('[name="id"]');
      const id = selected?.value;
      if (!id || button.disabled) return;
      if (button.hasAttribute('data-rcc-restricted')) {
        location.href = form.closest('[data-rcc-card]')?.querySelector('.rcc__name')?.href || '/cart';
        return;
      }
      button.disabled = true;
      if (feedback) feedback.textContent = '';
      try {
        const response = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(id),quantity:1}]}),signal
        });
        if (!response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || errorText || 'Could not add item');
        }
        await refreshCart(Number(id));
        if (feedback) feedback.textContent = addedText || 'Added to bag';
        const label = button.querySelector('[data-rcc-button-label]');
        if (label) label.textContent = addedText || 'Added to bag';
      } catch(error) {
        if (error.name === 'AbortError') return;
        if (feedback) feedback.textContent = error.message || errorText || 'Try again';
        if (!navigator.onLine) button.disabled = false;
        else if (error.message === 'Cart fetch failed' || error.message === 'Cart sections failed' || error.message === 'Missing refreshed cart section' || error.message === 'Incomplete cart section') {
          location.reload();
          return;
        } else button.disabled = false;
      } finally {
        if (document.contains(button)) button.disabled = false;
      }
    }

    root.addEventListener('change', event => {
      if (event.target.matches('.rcc__select')) updateVariant(event.target);
    }, {signal});
    root.addEventListener('submit', addItem, {signal});
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) return;
      observer.disconnect();
      showRecommendations();
    },{rootMargin:'350px'});
    observer.observe(root);
    adjust();
    instances.set(root, () => {controller.abort();observer.disconnect();instances.delete(root);});
  }

  function initIn(scope) {
    if (scope.matches?.('[data-rcc-root]')) setup(scope);
    scope.querySelectorAll?.('[data-rcc-root]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initIn(document), {once:true});
  else initIn(document);
  document.addEventListener('shopify:section:load',event => initIn(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll?.('[data-rcc-root]').forEach(node=>instances.get(node)?.()));
})();